<template>
  <div class="container">
    <div class="wx-header">
      <div class="wh-content">
        <div class="wh-tit" style="margin-top: 158px">微商城</div>
        <div class="wh-tit">售货就这么简单</div>
        <div class="wh-btn" @click.stop="gotowx">立即开通</div>
      </div>
    </div>
    <div class="wx-process">
      <div class="wp-content">
        <div class="wpc-tit">开通流程</div>
        <div class="wpc-tip">操作简单，快速开启您的线上销售渠道</div>
        <div class="wpc-list">
          <div class="wpcl-item">
            <img src="@/assets/newdownload/wpcl1.png" alt="" class="item-img" />
            <div class="item-tit">第一步.开通应用</div>
            <div class="item-tip">
              登录收银系统后台，在应用市场找到微商城，进行开通
            </div>
            <img src="@/assets/newdownload/wpclp.png" alt="" class="item-pos" />
          </div>
          <div class="wpcl-item">
            <img src="@/assets/newdownload/wpcl2.png" alt="" class="item-img" />
            <div class="item-tit">第二步.授权小程序</div>
            <div class="item-tip">
              在「微商城-第三方授权」进行小程序授权，若无小程序请先申请小程序
            </div>
            <img src="@/assets/newdownload/wpclp.png" alt="" class="item-pos" />
          </div>
          <div class="wpcl-item">
            <img src="@/assets/newdownload/wpcl3.png" alt="" class="item-img" />
            <div class="item-tit">第三步.微商城设置</div>
            <div class="item-tip">
              对商城配置、商品进行自定义设置，打造专属微商城
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="wx-stock">
      <div class="wxs-content">
        <div class="wxsc-tit">独立商品库</div>
        <div class="wxsc-tip">
          微商城支持单独设置商品信息，为不同业务场景的商户提供不同的应用能力
        </div>
        <!-- <img src="@/assets/newdownload/wxsc.png" alt="" class="wxsc-img" /> -->
        <div class="wxsc-row" @mouseleave="mouseTrack = 1">
          <div
            :class="mouseTrack == 1 ? 'wxsc-item' : 'wxsc-item hid'"
            @mouseenter="mouseTrack = 1"
          >
            <img
              src="@/assets/newdownload/wxscr3.png"
              alt=""
              class="wxscr-img"
            />
          </div>
          <div
            :class="mouseTrack == 2 ? 'wxsc-item' : 'wxsc-item hid'"
            @mouseenter="mouseTrack = 2"
          >
            <img
              src="@/assets/newdownload/wxscr2.png"
              alt=""
              class="wxscr-img"
            />
          </div>
          <div
            :class="mouseTrack == 3 ? 'wxsc-item' : 'wxsc-item hid'"
            @mouseenter="mouseTrack = 3"
          >
            <img
              src="@/assets/newdownload/wxscr1.png"
              alt=""
              class="wxscr-img"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="wx-track">
      <div class="wxt-content">
        <div class="wxtc-tit">订单智能跟踪</div>
        <div class="wxtc-tip">
          微商城订单单独汇总，商家可清楚了解订单状态并对订单进行相应操作
        </div>
        <!-- <div class="wxtc-img"></div> -->
        <img src="@/assets/newdownload/wxtci.png" alt="" class="wxtc-img" />
      </div>
    </div>
    <div class="wx-prop">
      <div class="wxp-content">
        <div class="wxpc-left">
          <div class="wxpcl-tit">店铺宣传秒触达</div>
          <div class="wxpcl-tip">
            商家可以在「商城配置」中上传公告、banner，快速精准触达用户
          </div>
          <div class="wxpcl-item" style="margin-top: 52px">
            <div class="wxpcli-top">
              <img
                src="@/assets/newdownload/wxpclit1.png"
                alt=""
                class="wxpclit-img"
              />
              <span class="wxpclit-word">玩法多样</span>
            </div>
            <div class="wxpcli-bottom">
              可进行广告投放、活动预告以及公告通知等多种宣传
            </div>
          </div>
          <div class="wxpcl-item" style="margin-top: 20px">
            <div class="wxpcli-top">
              <img
                src="@/assets/newdownload/wxpclit2.png"
                alt=""
                class="wxpclit-img"
              />
              <span class="wxpclit-word">操作简单</span>
            </div>
            <div class="wxpcli-bottom">商家直接上传宣传图/公告内容即可</div>
          </div>
        </div>
        <img src="@/assets/newdownload/wxpcr.png" alt="" class="wxpc-right" />
      </div>
    </div>
    <div class="wx-channel">
      <div class="wxc-content">
        <div class="wxcc-tit">多渠道开店</div>
        <div class="wxcc-tip">打通微信、支付宝、抖音等多个平台，多渠道引流</div>
        <div class="wxcc-tip1">
          部分平台微商城正努力开发中，请以实际开通为准
        </div>
        <div class="wxcc-list">
          <div class="wxccl-item">
            <img
              src="@/assets/newdownload/wxccl1.png"
              alt=""
              class="wxccl-icon"
            />
            <div class="wxccl-word">H5微商城</div>
          </div>
          <div class="wxccl-item">
            <img
              src="@/assets/newdownload/wxccl2.png"
              alt=""
              class="wxccl-icon"
            />
            <div class="wxccl-word">微信小程序</div>
          </div>
          <div class="wxccl-item">
            <img
              src="@/assets/newdownload/wxccl3.png"
              alt=""
              class="wxccl-icon"
            />
            <div class="wxccl-word">支付宝小程序</div>
          </div>
          <div class="wxccl-item">
            <img
              src="@/assets/newdownload/wxccl4.png"
              alt=""
              class="wxccl-icon"
            />
            <div class="wxccl-word">抖音小店</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "webproduct",
  data() {
    return {
      mouseTrack: 1,
      // swiperOption6: {
      //   loop: true,
      //   // loopAdditionalSlides: 6,
      //   autoplay: {
      //     delay: 3000,
      //     // stopOnLastSlide: false,
      //     disableOnInteraction: false,
      //   },
      // },
      // featureList: [
      //   {
      //     id: 1,
      //     img: require("@/assets/system1.png"),
      //     tit: "全新界面",
      //     tip: "界面全新升级，操作简单，用户可以快速上手，",
      //     tip1: "告别繁杂的培训学习",
      //   },
      //   {
      //     id: 2,
      //     img: require("@/assets/system2.png"),
      //     tit: "一体化营销",
      //     tip: "公众号、小程序、微信群、企业微信互联互通，",
      //     tip1: "流量变现快速高效，促销多样化",
      //   },
      //   {
      //     id: 3,
      //     img: require("@/assets/system3.png"),
      //     tit: "开放式API对接",
      //     tip: "开放式API支持打通各大会员系统、供应链、",
      //     tip1: "WMS系统、TMS系统等",
      //   },
      //   {
      //     id: 4,
      //     img: require("@/assets/system4.png"),
      //     tit: "全新框架",
      //     tip: "云技术高性能框架搭建的收银系统，性能稳定，",
      //     tip1: "简单易用，各机构数据实时同步",
      //   },
      //   {
      //     id: 5,
      //     img: require("@/assets/system5.png"),
      //     tit: "云端同步",
      //     tip: "采用全新同步技术和增加本地缓存库，遇到断网",
      //     tip1: "等突发情况开启自动保护机制",
      //   },
      //   {
      //     id: 6,
      //     img: require("@/assets/system6.png"),
      //     tit: "硬件无忧",
      //     tip: "兼容Windows、苹果IOS、安卓，不管使用什么",
      //     tip1: "设备，都有对应的客户端为您快速提升效率",
      //   },
      // ],
    };
  },
  methods: {
    go() {
      location.href = "https://www.fp1123.com/fpPos/#/login";
    },
    gotowx() {
      location.href = "https://www.fp1123.com/fpPos/#/microMall/mallSituation";
    },
  },
  activated() {
    // this.$nextTick(() => {
    //   this.$wow.init();
    // });
  },
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  min-width: 1420px;
  background: #fff;
  position: relative;
  top: 64px;
}
.mixin-word() {
  font-family: "Noto Sans SC";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
}
.wx-header {
  width: 100%;
  height: 560px;
  background: url("~@/assets/newdownload/headerwx.png");
  display: flex;
  // align-items: center;
  justify-content: center;
  .wh-content {
    width: 1200px;
    display: flex;
    flex-direction: column;
    .wh-tit {
      .mixin-word;
      font-weight: 500;
      font-size: 72px;
      line-height: 142%;
      color: #1f2329;
    }
    .wh-btn {
      margin-top: 69px;
      width: 224px;
      height: 54px;
      background: #2f54eb;
      box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
      border-radius: 6px;
      .mixin-word;
      font-size: 20px;
      line-height: 54px;
      color: #ffffff;
      text-align: center;
      cursor: pointer;
      &:hover {
        background: #5c8cff;
        box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
      }
    }
  }
}
.wx-process {
  width: 100%;
  height: 578px;
  background: linear-gradient(180deg, #ffffff 29.67%, #f9fcff 100%);
  display: flex;
  justify-content: center;
  .wp-content {
    width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .wpc-tit {
      margin-top: 24px;
      .mixin-word;
      font-size: 40px;
      line-height: 48px;
      color: #1f2329;
    }
    .wpc-tip {
      margin-top: 16px;
      font-size: 18px;
      line-height: 26px;
      color: #51565d;
    }
    .wpc-list {
      margin-top: 50px;
      padding: 24px 24px 48px;
      height: 354px;
      background: #ffffff;
      display: flex;
      // align-items: flex-start;
      // justify-content: space-between;
      gap: 102px;
      .wpcl-item {
        width: 316px;
        height: 282px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        .item-pos {
          position: absolute;
          top: 23%;
          right: -58%;
          width: 261px;
          height: 25px;
        }
        .item-img {
          width: 160px;
          height: 160px;
          background: #f3f7fe;
          border-radius: 100px;
        }
        .item-tit {
          margin-top: 36px;
          .mixin-word;
          font-weight: 500;
          font-size: 22px;
          line-height: 28px;
          color: #292929;
        }
        .item-tip {
          margin-top: 10px;
          .mixin-word;
          font-size: 16px;
          line-height: 24px;
          color: #51565d;
          text-align: center;
        }
      }
      // .wpcl-item + .wpcl-item {
      //   margin-left: 102px;
      // }
    }
  }
}
.wx-stock {
  width: 100%;
  height: 794px;
  display: flex;
  // align-items: center;
  justify-content: center;
  .wxs-content {
    width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .wxsc-tit {
      margin-top: 78px;
      .mixin-word;
      font-size: 40px;
      line-height: 48px;
      color: #1f2329;
    }
    .wxsc-tip {
      margin-top: 16px;
      .mixin-word;
      font-size: 18px;
      line-height: 26px;
      color: #51565d;
    }
    // .wxsc-img {
    //   margin-top: 56px;
    //   width: 1200px;
    //   height: 470px;
    // }
    .wxsc-row {
      margin-top: 56px;
      display: flex;
      cursor: pointer;
      gap: 35px;
      .wxsc-item {
        width: 510px;
        height: 470px;
        border-radius: 20px;
        transition: all 0.5s;
        overflow: hidden;
        &.wid1 {
          width: 481px;
        }
        &.wid2 {
          width: 495px;
        }
        &.hid {
          width: 310px;
        }
        .wxsc-img {
          height: 470px;
          filter: drop-shadow(0px 8px 24px rgba(74, 130, 183, 0.1));
        }
      }
    }
  }
}
.wx-track {
  width: 100%;
  height: 744px;
  background: #f6f7fb;
  display: flex;
  justify-content: center;
  .wxt-content {
    width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .wxtc-tit {
      margin-top: 78px;
      .mixin-word;
      font-size: 40px;
      line-height: 48px;
      color: #1f2329;
    }
    .wxtc-tip {
      margin-top: 16px;
      .mixin-word;
      font-size: 18px;
      line-height: 26px;
      color: #51565d;
    }
    .wxtc-img {
      margin-top: 56px;
      width: 1200px;
      height: 420px;
    }
  }
}
.wx-prop {
  width: 100%;
  height: 680px;
  display: flex;
  justify-content: center;
  .wxp-content {
    width: 1200px;
    display: flex;
    align-items: center;
    .wxpc-left {
      flex-shrink: 0;
      // margin-top: 262px;
      width: 405px;
      height: 312px;
      display: flex;
      flex-direction: column;
      // align-items: center;
      .wxpcl-tit {
        .mixin-word;
        font-size: 40px;
        line-height: 56px;
        color: #292929;
        align-self: center;
      }
      .wxpcl-tip {
        margin-top: 16px;
        .mixin-word;
        font-size: 18px;
        line-height: 26px;
        color: #51565d;
      }
      .wxpcl-item {
        display: flex;
        flex-direction: column;
        .wxpcli-top {
          display: flex;
          align-items: center;
        }
        .wxpclit-img {
          width: 20px;
          height: 20px;
          margin-right: 10px;
        }
        .wxpclit-word {
          .mixin-word;
          font-size: 20px;
          line-height: 28px;
          color: #292929;
        }
        .wxpcli-bottom {
          margin-left: 30px;
          margin-top: 6px;
          .mixin-word;
          color: #455770;
        }
      }
    }
    .wxpc-right {
      margin-left: 55px;
      width: 699.94px;
      height: 520px;
    }
  }
}
.wx-channel {
  width: 100%;
  height: 540px;
  display: flex;
  justify-content: center;
  background: url("~@/assets/newdownload/wxchannel.png");
  .wxc-content {
    width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .wxcc-tit {
      margin-top: 79px;
      .mixin-word;
      font-size: 40px;
      line-height: 48px;
      color: #1f2329;
    }
    .wxcc-tip {
      margin-top: 16px;
      .mixin-word;
      font-size: 18px;
      line-height: 26px;
      color: #51565d;
    }
    .wxcc-tip1 {
      margin-top: 8px;
      .mixin-word;
      font-size: 14px;
      line-height: 20px;
      color: rgba(0, 0, 0, 0.45);
    }
    .wxcc-list {
      margin-top: 50px;
      display: flex;
      align-items: center;
      // justify-content: space-around;
      gap: 180px;
      .wxccl-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        .wxccl-icon {
          width: 120px;
          height: 120px;
        }
        .wxccl-word {
          margin-top: 16px;
          .mixin-word;
          font-size: 18px;
          line-height: 36px;
          color: #1f2329;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/productwx.vue